var _path, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStreamlineConversations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 56.591 61.229",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_24964",
    "data-name": "Path 24964",
    d: "M1.25,26.332v2.62a1.98,1.98,0,0,0,1.979,1.979H29.615a1.98,1.98,0,0,0,1.979-1.979v-2.62c0-2.034-1.177-4.005-3.412-5.53-2.654-1.813-6.929-3.045-11.76-3.045S7.316,18.989,4.662,20.8c-2.235,1.525-3.412,3.5-3.412,5.53Z",
    transform: "translate(0 29.048)",
    fill: "none",
    stroke: "#96006b",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    fillRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_997",
    "data-name": "Ellipse 997",
    cx: 8.575,
    cy: 8.575,
    r: 8.575,
    transform: "translate(7.846 29.636)",
    fill: "none",
    stroke: "#96006b",
    strokeLinecap: "round",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24965",
    "data-name": "Path 24965",
    d: "M53.7,5.868A4.621,4.621,0,0,0,49.085,1.25H6.868A4.621,4.621,0,0,0,2.25,5.868V21.7a4.618,4.618,0,0,0,4.618,4.618H30.615a.66.66,0,0,1,.66.66v7.916a1.978,1.978,0,0,0,3.562,1.187l7.124-9.5a.657.657,0,0,1,.528-.264h6.6A4.618,4.618,0,0,0,53.7,21.7ZM13.464,17.741a3.958,3.958,0,1,0-3.958-3.958A3.959,3.959,0,0,0,13.464,17.741Zm14.512,0a3.958,3.958,0,1,0-3.958-3.958A3.959,3.959,0,0,0,27.976,17.741Zm14.512,0a3.958,3.958,0,1,0-3.958-3.958A3.959,3.959,0,0,0,42.488,17.741Z",
    transform: "translate(1.639)",
    fill: "none",
    stroke: "#ff0185",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineConversations);
export default __webpack_public_path__ + "static/media/StreamlineConversations.2265e88e16faa38c0e86e4a7767a4028.svg";
export { ForwardRef as ReactComponent };